export const CHECKOUT_INFO_PAGE_TEST_ID = {
  submitButton: 'email-address-submit',
  firstName: 'first-name',
  lastName: 'last-name',
  businessName: 'business-name',
  businessZipCode: 'business-zip',
  emailAddress: 'email-address',
  confirmEmailAddress: 'confirm-email-address',
};
